import { useState, useEffect } from 'react';
import { getQueueLength, zosOutboxCount } from '@/services/db';

interface OfflineStatus {
  isOnline: boolean;
  /** Wartende Requests gesamt: generische Offline-Queue + ZOS-Antworten-Outbox. */
  pendingRequests: number;
}

export function useOfflineStatus(): OfflineStatus {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingRequests, setPendingRequests] = useState(0);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check pending requests periodically (Queue + Wizard-Outbox)
    const checkPending = async () => {
      try {
        const [queue, outbox] = await Promise.all([
          getQueueLength().catch(() => 0),
          zosOutboxCount().catch(() => 0),
        ]);
        setPendingRequests(queue + outbox);
      } catch {
        // Ignore errors
      }
    };

    checkPending();
    const interval = setInterval(checkPending, 5000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(interval);
    };
  }, []);

  return { isOnline, pendingRequests };
}
